import { render, staticRenderFns } from "./TopicModal.vue?vue&type=template&id=72fad09a&"
import script from "./TopicModal.vue?vue&type=script&lang=js&"
export * from "./TopicModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports